import { createContext, useContext, useEffect, useState } from "react";
import { meta, productParams } from "../lib/metaPixel";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("phudg_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("phudg_cart", JSON.stringify(items));
  }, [items]);

  const add = ({ slug, name, image, size, price }, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.slug === slug && i.size === size);
      if (existing) {
        return prev.map((i) =>
          i.slug === slug && i.size === size ? { ...i, qty: i.qty + qty } : i
        );
      }
      return [...prev, { slug, name, image, size, price, qty }];
    });
    meta.addToCart(productParams({ slug, name, size, price }, qty));
  };

  const setQty = (slug, size, qty) => {
    if (qty < 1) return;
    setItems((prev) =>
      prev.map((i) => (i.slug === slug && i.size === size ? { ...i, qty } : i))
    );
  };

  const remove = (slug, size) =>
    setItems((prev) => prev.filter((i) => !(i.slug === slug && i.size === size)));

  const clear = () => setItems([]);

  const total = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, total, count }}>
      {children}
    </CartContext.Provider>
  );
};
